import { AptiveIcon, Button, Modal } from '@aptive-env/storybook'
import { eventValidationConstants } from 'constants/index'
interface DataContent {
  title: string,
  content: string
}
interface EventDataWarningModalProps {
  open: boolean,
  data: DataContent,
  onClickGoBack: () => void
  onClickSave: (data?: string) => void
}

const { EVENT_TITLE_MISSING_WARNING_TITLE, EVENT_PAST_DATE_WARNING_TITLE } = eventValidationConstants

export const EventDataWarningModal: React.FC<EventDataWarningModalProps> = ({
  open,
  data,
  onClickGoBack,
  onClickSave,
}) => {
  const handleClickSave = () => {
    if (data.title === EVENT_TITLE_MISSING_WARNING_TITLE || data.title === EVENT_PAST_DATE_WARNING_TITLE)
      onClickSave(data.title)
    else
      onClickSave()
  }

  return (
    <Modal open={open} className="w-[500px]">
      <div className="p-5">
        <div className="flex gap-3">
          <div className="bg-[#fce8e8] w-[40px] h-[40px] rounded-[50%] flex-none flex items-center justify-center">
            <AptiveIcon
              className="w-[24px] h-[24px] stroke-[#c81e1d] fill-none"
              icon="exclamation"
            />
          </div>
          <div>
            <div className="text-xl font-light">{data.title}</div>
            <div className="text-xs text-aro-gray mt-2">{data.content}</div>
          </div>
        </div>
        <div className="flex justify-end mt-3">
          <Button
            size="small"
            variant="neutral"
            onClick={onClickGoBack}
          >
            Go back
          </Button>
          <Button
            size="small"
            variant="danger"
            className="ml-2"
            onClick={handleClickSave}
          >
            Save
          </Button>
        </div>
      </div>
    </Modal>
  )
}
